import { gql } from '@apollo/client'

export const Query = gql`
  query Packages($companyId: ID!, $filters: PackageFilters, $order: PackageOrder, $after: String, $before: String, $first: Int, $last: Int) {
    packages(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        categories {
          id
          name
          color
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
